import React from 'react'
import { Typography } from '@mui/material'

interface CharacterCounterProps {
  current: number
  max: number
}

const CharacterCounter: React.FC<CharacterCounterProps> = ({ current, max }) => {
  const ratio = current / max

  let color: string
  if (ratio > 0.95) {
    color = '#f44336' // red
  } else if (ratio > 0.80) {
    color = '#ff9800' // yellow/amber
  } else {
    color = 'text.secondary'
  }

  return (
    <Typography
      variant="caption"
      aria-live="polite"
      sx={{ color, transition: 'color 0.2s ease' }}
    >
      {current.toLocaleString()}/{max.toLocaleString()}
    </Typography>
  )
}

export default CharacterCounter
